<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    ok-title="Accept"
    size="lg"
    title="Upload Patient Scan"
    title-tag="h5"
    cancel-title="Close"
    id="idUploadScanModal"
    cancel-variant="outline-primary"
    :ok-disabled="droppedFiles.length === 0"
    @shown="clearDiscoveredData"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <b-col>
          <vue-dropzone
            ref="vueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            @vdropzone-file-added="fileAdded"
          ></vue-dropzone>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            id="idClearBtn"
            variant="primary"
            size="sm"
            @click="clearDiscoveredData"
            >Clear</b-button
          >
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import blacklist from "@/data/blacklist";
import dicomParser from "dicom-parser";
import moment from "moment";
import * as JSZip from "jszip";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  data() {
    return {
      discoveredFirstName: null,
      discoveredLastName: null,
      discoveredDateOfBirth: null,
      discoveredGender: null,
      processedFile: null,
      processedDirectory: [],
      droppedFiles: [],
      dropzoneOptions: {
        previewTemplate: this.template(),
        createImageThumbnails: false,
        url: "http://stryker.com",
        autoProcessQueue: false,
        dictDefaultMessage:
          "Upload a file/folder by dragging and dropping here, or click to browse for a zip file",
        headers: { "My-Awesome-Header": "header value" },
      },
    };
  },
  props: [],
  components: {
    vueDropzone: vue2Dropzone,
  },
  methods: {
    fileAdded(file) {
      if (
        file.fullPath ||
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed" ||
        file.name.endsWith(".zip")
      ) {
        if (
          this.droppedFiles.filter((f) => f.name.endsWith(".zip")).length > 0 ||
          (file.name.endsWith(".zip") && this.droppedFiles.length > 0)
        ) {
          this.$refs.vueDropzone.removeFile(file);
          this.$root.$emit("showAlert", {
            type: "error",
            msg: "You can only add a single zip file.",
            force: true,
          });
        } else {
          this.droppedFiles.push(file);
        }
      } else {
        this.$refs.vueDropzone.removeAllFiles();
        this.droppedFiles = [];
        this.$root.$emit("showAlert", {
          type: "error",
          msg:
            "You added a file of the type " +
            file.type +
            ". Please add either a zip file or a folder.",
          force: true,
        });
      }
    },
    template() {
      return `
<div class="files" id="previews">
  <div id="template" class="file-row">
    <!-- This is used as the file preview template -->
    <li class="dz-filename">
        <span data-dz-name></span>
        <span class="size" data-dz-size></span>
    </li>
  </div>
</div>
        `;
    },
    async onOk() {
      // Single file => Zip Workflow
      if (this.droppedFiles.length === 1) {
        const file = this.droppedFiles[0];

        // Unzip file for dicom read
        const unzip = new JSZip();
        await unzip
          .loadAsync(file)
          .then((content) => {
            // Skip corrupt data
            for (const file in content.files) {
              if (!Object.prototype.hasOwnProperty.call(content.files, file))
                continue;
              if (content.files[file].dir) continue;
              if (content.files[file].name.startsWith("__MACOSX")) continue;
              return content.files[file];
            }
          })
          .then((zippedFile) => zippedFile.async("blob"))
          // Parse dicom
          .then((blob) => this.parseDicomFiles(blob))
          .then(
            (result) => {
              this.$emit("okClicked", {
                droppedFile: file,
                droppedDirectory: null,
                discoveredFirstName: result.firstName,
                discoveredLastName: result.lastName,
                discoveredDateOfBirth: moment(result.dateOfBirth).format(
                  "YYYY-MM-DD"
                ),
                discoveredGender: result?.gender?.toLowerCase(),
                referringPhysician: result?.referringPhysician,
                fullName: result?.fullName,
              });
            },
            (error) => {
              this.$root.$emit("showAlert", {
                type: "error",
                msg: "Error while parsing dicom data: " + error,
              });
              this.processedFile = null;
              // eslint-disable-next-line
              console.log(error);
            }
          );
      } else {
        // Else we can read files directly
        //Check for blacklisted Items
        this.droppedFiles.forEach((file) => {
          var fileEnding = file.name.substring(file.name.lastIndexOf("."));
          if (!blacklist.some((x) => x.includes(fileEnding))) {
            this.processedDirectory.push(file);
          }
        });

        // parse dicom files and find Metadata
        try {
          var promises = this.processedDirectory.map((dicom) =>
            this.parseDicomFiles(dicom)
          );
          Promise.all(promises).then((results) => {
            results.forEach((result) => {
              if (result.firstName) this.discoveredFirstName = result.firstName;
              if (result.lastName) this.discoveredLastName = result.lastName;
              if (result.dateOfBirth)
                this.discoveredDateOfBirth = moment(result.dateOfBirth).format(
                  "YYYY-MM-DD"
                );
              if (result.gender) this.discoveredGender = result.gender;
              if (result.referringPhysician)
                this.referringPhysician = result.referringPhysician;
              if (result.fullName) this.fullName = result.fullName;
            });
            this.$emit("okClicked", {
              droppedFile: this.processedFile,
              droppedDirectory: this.processedDirectory,
              discoveredFirstName: this.discoveredFirstName
                ? this.discoveredFirstName
                : "",
              discoveredLastName: this.discoveredLastName
                ? this.discoveredLastName
                : "",
              discoveredDateOfBirth: this.discoveredDateOfBirth
                ? this.discoveredDateOfBirth
                : "",
              discoveredGender: this.discoveredGender
                ? this.discoveredGender.toLowerCase()
                : "",
              referringPhysician: this.referringPhysician,
              fullName: this.fullName,
            });
          });
        } catch (error) {
          this.$root.$emit("showAlert", {
            type: "error",
            msg: "Error while parsing dicom data: " + error,
          });
          this.processedDirectory = [];
        }
      }
    },
    clearDiscoveredData() {
      this.droppedFiles = [];
      this.processedFile = null;
      this.processedDirectory = [];
      this.discoveredFirstName = null;
      this.discoveredLastName = null;
      this.discoveredDateOfBirth = null;
      this.discoveredGender = null;
      this.$refs.vueDropzone.removeAllFiles();
    },
    parseDicomFiles(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = function () {
          var arrayBuffer = reader.result;
          var byteArray = new Uint8Array(arrayBuffer);

          try {
            // Parse the byte array to get a DataSet object that has the parsed contents
            var dataSet = dicomParser.parseDicom(byteArray /*, options */);
          } catch (ex) {
            reject(new Error("Error parsing byte stream", ex));
          }

          // Read dicom data
          const patientDob = dataSet.string("x00100030");
          const patientGender = dataSet.string("x00100040");

          // Manually decode name and physician to account for special characters
          const patientName = toDecodedString(dataSet, "x00100010");
          const referringPhysician = toDecodedString(dataSet, "x00080090");

          var result = {};
          result.referringPhysician = referringPhysician;
          result.fullName = patientName;

          if (patientName) {
            var namesCount = patientName.match(/\^/g);
            if (!namesCount) {
              // Only last name
              result.lastName = patientName;
            } else {
              // char "^" found, so we need to split
              var [lastName, firstName] = patientName.split(/\^(.+)/);
              result.firstName = firstName;
              result.lastName = lastName;
            }
          }

          // Handle DoB
          result.dateOfBirth = patientDob
            ? moment(patientDob).format("YYYY-MM-DD")
            : null;
          switch (patientGender) {
            case "F":
              result.gender = "Female";
              break;
            case "M":
              result.gender = "Male";
              break;
            case "O":
            default:
              result.gender = null;
              break;
          }
          resolve(result);

          function toDecodedString(dataIn, dicomTag) {
            // Manually slice out the relevant bytes and decode into UTF-8
            let decodedName = "";
            if (dataSet.string(dicomTag)) {
              const index = dataIn.elements[dicomTag].dataOffset;
              const length = dataIn.elements[dicomTag].length;
              const newArray = dataIn.byteArray.slice(index, index + length);
              decodedName = new TextDecoder().decode(newArray);
            }
            return decodedName;
          }
        };
        reader.readAsArrayBuffer(file);
      });
    },
  },
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin: 0.8rem 0;
}
.dropzone {
  height: 15rem;
  min-height: 0px !important;
  overflow-y: scroll;
}
.files {
  font-size: small;
  margin-bottom: 0px !important;
}
</style>